/* Robles: favoritos guardados en este navegador (sin apps ni peticiones en el catálogo). */
(() => {
  const CLAVE = 'rv_favoritos';
  const MAXIMO = 60;

  function leer() {
    try {
      const lista = JSON.parse(localStorage.getItem(CLAVE));
      return Array.isArray(lista) ? lista.filter((handle) => typeof handle === 'string' && handle) : [];
    } catch (error) {
      return [];
    }
  }

  function guardar() {
    try {
      localStorage.setItem(CLAVE, JSON.stringify(favoritos));
    } catch (error) {
      // Sin almacenamiento disponible: el corazón funciona solo en esta visita.
    }
  }

  let favoritos = leer();

  function pintarBoton(boton) {
    boton.setAttribute('aria-pressed', favoritos.includes(boton.dataset.rvFav) ? 'true' : 'false');
  }

  /* Formato según data-rv-fav-count: "numero" → 3, "productos" → 3 productos,
     "guardados" → 3 productos guardados; vacío → (3). */
  function textoContador(formato, total) {
    const plural = total !== 1;
    if (formato === 'numero') return String(total);
    if (formato === 'productos') return `${total} ${plural ? 'productos' : 'producto'}`;
    if (formato === 'guardados') return `${total} ${plural ? 'productos guardados' : 'producto guardado'}`;
    return `(${total})`;
  }

  function pintarContadores() {
    const total = favoritos.length;
    document.querySelectorAll('[data-rv-fav-count]').forEach((contador) => {
      // En la burbuja del header el número va en su <span>, igual que en la del carrito.
      const destino = contador.firstElementChild || contador;
      destino.textContent = total === 0 ? '' : textoContador(contador.dataset.rvFavCount, total);
      contador.hidden = total === 0;
    });
  }

  function pintarTodo() {
    document.querySelectorAll('[data-rv-fav]').forEach(pintarBoton);
    pintarContadores();
  }

  /* "Ver favoritos": recuerda dónde estaba el cliente para devolverlo ahí al regresar.
     Los filtros viven en la dirección (facets.js usa pushState), así que basta la URL y el scroll. */
  const CLAVE_REGRESO = 'rv_fav_regreso';

  function recordarRegreso() {
    try {
      sessionStorage.setItem(CLAVE_REGRESO, JSON.stringify({ url: window.location.href, y: Math.round(window.scrollY) }));
    } catch (error) {
      // Sin sessionStorage el navegador sigue restaurando la página por su cuenta.
    }
  }

  function leerRegreso() {
    try {
      const regreso = JSON.parse(sessionStorage.getItem(CLAVE_REGRESO));
      return regreso && regreso.url === window.location.href ? regreso : null;
    } catch (error) {
      return null;
    }
  }

  function olvidarRegreso() {
    try {
      sessionStorage.removeItem(CLAVE_REGRESO);
    } catch (error) {
      // Nada que limpiar.
    }
  }

  /* Si el navegador conservó la página al regresar, ya está todo en su lugar. Si la tuvo que
     recargar, se vuelve a la misma altura, salvo que el cliente ya se haya movido. */
  function restaurarRegreso() {
    const regreso = leerRegreso();
    if (!regreso) return;
    olvidarRegreso();
    const navegacion = performance.getEntriesByType('navigation')[0];
    if (!navegacion || navegacion.type !== 'back_forward') return;

    let seMovio = false;
    const marcar = () => {
      seMovio = true;
    };
    ['wheel', 'touchstart', 'keydown'].forEach((tipo) => window.addEventListener(tipo, marcar, { once: true, passive: true }));
    const ir = () => {
      if (!seMovio && Math.abs(window.scrollY - regreso.y) > 40) window.scrollTo(0, regreso.y);
    };
    requestAnimationFrame(ir);
    window.addEventListener('load', ir, { once: true });
  }

  /* Dirección de "Mis favoritos": los enlaces del header y del menú solo existen si la página
     existe. Dentro de la propia página de favoritos no hace falta el enlace. */
  function urlFavoritos() {
    const enlace = document.querySelector('a.rv-fav-header, a.rv-menu-favoritos, a.rv-fav-enlace');
    if (!enlace) return null;
    const url = new URL(enlace.href, window.location.href);
    return url.pathname === window.location.pathname ? null : url.href;
  }

  /* Aviso inferior. Con "Ver favoritos" dura más y se pausa mientras el cliente lo señala o lo
     enfoca, para que alcance a leerlo y tocarlo; nunca abre favoritos por sí solo. */
  const DURACION_AVISO = 2400;
  const DURACION_AVISO_CON_ENLACE = 6000;
  let aviso;
  let avisoTimer;
  let avisoRestante = 0;
  let avisoDesde = 0;
  let avisoPausado = false;

  function programarCierre(ms) {
    clearTimeout(avisoTimer);
    avisoRestante = ms;
    avisoDesde = Date.now();
    avisoTimer = setTimeout(() => aviso.classList.remove('is-visible'), ms);
  }

  function pausarAviso() {
    if (avisoPausado || !aviso.classList.contains('is-visible')) return;
    avisoPausado = true;
    clearTimeout(avisoTimer);
    avisoRestante -= Date.now() - avisoDesde;
  }

  function reanudarAviso() {
    if (!avisoPausado) return;
    avisoPausado = false;
    programarCierre(Math.max(avisoRestante, 1500));
  }

  function avisar(texto, conEnlace = false) {
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'rv-fav-aviso';
      aviso.setAttribute('role', 'status');
      aviso.innerHTML =
        '<svg class="rv-fav-aviso__icono" viewBox="0 0 28 28" aria-hidden="true" focusable="false"><circle cx="14" cy="14" r="14"/><path d="m8.5 14.5 3.5 3.5 7.5-8"/></svg>' +
        '<span class="rv-fav-aviso__texto"></span>' +
        '<a class="rv-fav-aviso__enlace" hidden>Ver favoritos<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14m-6-6 6 6-6 6"/></svg></a>';
      document.body.appendChild(aviso);
      aviso.addEventListener('pointerenter', pausarAviso);
      aviso.addEventListener('pointerleave', reanudarAviso);
      aviso.addEventListener('focusin', pausarAviso);
      aviso.addEventListener('focusout', reanudarAviso);
      aviso.querySelector('.rv-fav-aviso__enlace').addEventListener('click', recordarRegreso);
    }
    const url = conEnlace ? urlFavoritos() : null;
    const enlace = aviso.querySelector('.rv-fav-aviso__enlace');
    enlace.hidden = !url;
    if (url) enlace.href = url;
    aviso.querySelector('.rv-fav-aviso__texto').textContent = texto;
    aviso.classList.add('is-visible');
    avisoPausado = false;
    programarCierre(url ? DURACION_AVISO_CON_ENLACE : DURACION_AVISO);
  }

  document.addEventListener('click', (evento) => {
    const boton = evento.target.closest('[data-rv-fav]');
    if (!boton) return;
    evento.preventDefault();

    const handle = boton.dataset.rvFav;
    const posicion = favoritos.indexOf(handle);
    if (posicion === -1) {
      favoritos = [handle, ...favoritos].slice(0, MAXIMO);
    } else {
      favoritos.splice(posicion, 1);
    }
    guardar();

    document.querySelectorAll('[data-rv-fav]').forEach((otro) => {
      if (otro.dataset.rvFav === handle) pintarBoton(otro);
    });
    pintarContadores();
    avisar(posicion === -1 ? 'Guardado en favoritos' : 'Eliminado de favoritos', posicion === -1);
    if (posicion !== -1) {
      document.dispatchEvent(new CustomEvent('rv:favorito-quitado', { detail: { handle } }));
    }
  });

  /* Otra pestaña cambió la lista. */
  window.addEventListener('storage', (evento) => {
    if (evento.key !== CLAVE && evento.key !== null) return;
    favoritos = leer();
    pintarTodo();
  });

  /* Página restaurada con el botón "atrás": el navegador ya devolvió scroll y filtros. */
  window.addEventListener('pageshow', (evento) => {
    if (!evento.persisted) return;
    if (leerRegreso()) olvidarRegreso();
    favoritos = leer();
    pintarTodo();
  });

  /* Tarjetas que llegan después: filtros, vistos recientemente, pestañas, editor del tema. */
  new MutationObserver((cambios) => {
    let hayContadores = false;
    for (const cambio of cambios) {
      for (const nodo of cambio.addedNodes) {
        if (nodo.nodeType !== 1) continue;
        if (nodo.hasAttribute('data-rv-fav')) pintarBoton(nodo);
        nodo.querySelectorAll('[data-rv-fav]').forEach(pintarBoton);
        if (nodo.hasAttribute('data-rv-fav-count') || nodo.querySelector('[data-rv-fav-count]')) hayContadores = true;
      }
    }
    if (hayContadores) pintarContadores();
  }).observe(document.body, { childList: true, subtree: true });

  /* Lo usa la página "Mis favoritos" (assets/rv-favoritos-pagina.js), que solo se carga ahí. */
  window.rvFavoritos = {
    MAXIMO,
    lista: () => favoritos.slice(),
    reemplazar(nueva) {
      favoritos = nueva.slice(0, MAXIMO);
      guardar();
      pintarTodo();
    },
    avisar,
    textoContador
  };

  pintarTodo();
  restaurarRegreso();
})();
